/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the header component
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



/**
 * Used to create a style hook to utilise JSS
 */
import { Theme, makeStyles } from '@material-ui/core/styles';

/**
 * Used to signify the header as the appbar of the application.
 */

/**
 * Used to restrict the content width of the header.
 */

/**
 * Used to layout the header.
 */

/**
 * Used to layout the header.
 */

/**
 * Used to format text.
 */

/**
 * Used to style navigation.
 */

/**
 * Used to style links in the navigation.
 */
import Button from '@material-ui/core/Button';



/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Used to get the BCT Website URL.
 */

/*
 * ---------------------------------------------------------------------------------
 * Assets
 * ---------------------------------------------------------------------------------
 */



import { faBuilding } from '@fortawesome/pro-duotone-svg-icons/faBuilding';
import { ALL_INSTITUTIONS } from '@ngt/online-patient-management-ui';
import BreadcrumbContainer from './BreadcrumbContainer';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

interface IDrugBreadcrumbsProps {
    institutionName?: string;
    institutionCode?: string;
    showInstitution?: boolean;
    depotCode?: string;
    depotName?: string;
    showDepot?: boolean;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles<Theme>(theme => ({
    navLink: {
        borderRadius: 50,
        fontSize: '0.75rem',
        fontWeight: 500,
        textTransform: 'none',
        margin: theme.spacing(0.25, 0),

        // '&:hover': {
        //     backgroundColor: onlinePatientManagement.colors.secondary[50]
        // }
    }
}));

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

const DrugBreadcrumbs: React.FunctionComponent<IDrugBreadcrumbsProps> = ({
    institutionName,
    institutionCode,
    showInstitution,
    depotCode,
    depotName,
    showDepot
}) => {
    const classes = useStyles();

    const useInstitutionCode = institutionCode;

    const institution = institutionName ?
        institutionName :
        ALL_INSTITUTIONS;

    const institutionCompleteLink = `/drug-management/${useInstitutionCode}`;

    const institutionLink = useInstitutionCode ?
        institutionCompleteLink :
        '/drug-management';

    const depotLink = `/drug-management/depot/${depotCode}`;

    return (
        <BreadcrumbContainer>
            {
                !!showInstitution && !!institution && (
                    <Button
                        component={NavLink}
                        to={institutionLink}
                        color="inherit"
                        className={classes.navLink}
                        activeClassName={classes.navLinkActive}
                        startIcon={<FontAwesomeIcon icon={faBuilding} fixedWidth />}
                        size="small"
                    >
                        {institution}
                    </Button>
                )
            }
            {
                !!showDepot && (
                    <Button
                        component={NavLink}
                        to="/drug-management/depots"
                        color="inherit"
                        className={classes.navLink}
                        activeClassName={classes.navLinkActive}
                        startIcon={<FontAwesomeIcon icon={faBuilding} fixedWidth />}
                        size="small"
                    >
                        All Depots
                    </Button>
                )
            }
            {
                !!showDepot && depotCode && depotName && (
                    <Button
                        component={NavLink}
                        to={depotLink}
                        color="inherit"
                        className={classes.navLink}
                        activeClassName={classes.navLinkActive}
                        startIcon={<FontAwesomeIcon icon={faBuilding} fixedWidth />}
                        size="small"
                    >
                        {depotName}
                    </Button>
                )
            }
        </BreadcrumbContainer>
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default DrugBreadcrumbs;